import React from 'react';
import { RadioButton, RadioButtonGroup } from 'components/shared/RadioButtonGroup';
import styles from './KPILeanSelect.module.css';

function KPILeanSelect({ value, onChange }) {
  return (
    <RadioButtonGroup value={value} onChange={onChange}>
      <RadioButton className={styles.button} value="y">
        Left Y
      </RadioButton>
      <RadioButton className={styles.button} value="yRight">
        Right Y
      </RadioButton>
    </RadioButtonGroup>
  );
}

export default KPILeanSelect;
